<template>
    <div class="md-layout" v-cloak>
        <div class="md-layout-item md-size-25">
            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-green">
                    <div class="card-icon">
                        <md-icon>View Work</md-icon>
                    </div>
                    <h4 class="title">View Work</h4>
                </md-card-header>
                <md-card-content>
                    <div class="text-right">
                        <md-button @click="goBack" class="md-primary md-dense">
                            Back to List
                        </md-button>
                    </div>

                </md-card-content>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Name:</b><span v-html="work.name"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Call ID:</b><span v-html="work.call_id"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Vessel:</b><span v-html="work.vessel.name"></span></div>
                </div>
                <div class="md-layout">
                    <div class="md-layout-item"><b>Guidance:</b><span v-html="work.guidance.name"></span></div>

                </div>
            </md-card>

        </div>
        <div
                class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-75">
            <nav-tabs-card>
                <template slot="content">
                    <span class="md-nav-tabs-title">Work:</span>
                    <md-tabs class="md-info" md-alignment="left">
                        <md-tab id="tab-home" md-label="Items" md-icon="directions_boat">
                            <md-table v-model="tabs.firstTabs" @md-selected="onSelect">
                                <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                        md-selectable="multiple"
                                        md-auto-select
                                >
                                    <md-table-cell>{{ item.tab }}</md-table-cell>
                                    <md-table-cell>
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">Edit</md-tooltip>
                                        </md-button>
                                        <md-button class="md-just-icon md-simple md-danger">
                                            <md-icon>close</md-icon>
                                            <md-tooltip md-direction="top">Close</md-tooltip>
                                        </md-button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </md-tab>

                        <md-tab id="tab-pages" md-label="Details" md-icon="sort">
                            <md-table v-model="tabs.firstTabs" @md-selected="onSelect">
                                <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                        md-selectable="multiple"
                                        md-auto-select
                                >
                                    <md-table-cell>{{ item.tab }}</md-table-cell>
                                    <md-table-cell>
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">Edit</md-tooltip>
                                        </md-button>
                                        <md-button class="md-just-icon md-simple md-danger">
                                            <md-icon>close</md-icon>
                                            <md-tooltip md-direction="top">Close</md-tooltip>
                                        </md-button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </md-tab>

                        <md-tab id="tab-posts" md-label="server" md-icon="cloud">
                            <md-table v-model="tabs.firstTabs" @md-selected="onSelect">
                                <md-table-row
                                        slot="md-table-row"
                                        slot-scope="{ item }"
                                        md-selectable="multiple"
                                        md-auto-select
                                >
                                    <md-table-cell>{{ item.tab }}</md-table-cell>
                                    <md-table-cell>
                                        <md-button class="md-just-icon md-simple md-primary">
                                            <md-icon>edit</md-icon>
                                            <md-tooltip md-direction="top">Edit</md-tooltip>
                                        </md-button>
                                        <md-button class="md-just-icon md-simple md-danger">
                                            <md-icon>close</md-icon>
                                            <md-tooltip md-direction="top">Close</md-tooltip>
                                        </md-button>
                                    </md-table-cell>
                                </md-table-row>
                            </md-table>
                        </md-tab>
                    </md-tabs>
                </template>
            </nav-tabs-card>
        </div>

    </div>
</template>

<script>
import {
    NavTabsCard,
    TimeLine,
    TimeLineItem,
    PricingCard,
    TestimonialCard
} from '@/components';
export default {
    components: {
        NavTabsCard,
        PricingCard,
        TimeLine,
        TimeLineItem,
        TestimonialCard
    },

    data: () => ({
        work: {
            type: 'works',
            name: null,
            call_id: null,
            vessel_id: null,
            guidance: {
                id: null,
                type: 'guidances',
            },
            vessel: {
                id: null,
                type: 'vessels',
            },
            relationshipNames: ['guidance','vessel'],
        },
        tabs: {
            selected: [],
            responsive: false,
            firstTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            secondTabs: [
                {
                    tab: 'hhSign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'yashaya Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            thirdTabs: [
                {
                    tab: 'Sign contract for "What are conference organizers afraid of?"'
                },
                {
                    tab: 'Lines From Great Russian Literature? Or E-mails From My Boss?'
                },
                {
                    tab:
                            'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit'
                }
            ],
            users: [
                {
                    id: 1,
                    name: 'Dakota Rice',
                    salary: '$36,738',
                    country: 'Niger'
                },
                {
                    id: 2,
                    name: 'Minerva Hooper',
                    salary: '$23,738',
                    country: 'Curaçao'
                },
                {
                    id: 3,
                    name: 'Sage Rodriguez',
                    salary: '$56,142',
                    country: 'Netherlands'
                },
                {
                    id: 4,
                    name: 'Philip Chaney',
                    salary: '$38,735',
                    country: 'Korea, South'
                }
            ]
        }
    }),

    created () {
        this.get();
    },

    methods: {
        onSelect: function (items) {
            this.selected = items;
        },
        async get () {
            try {
                const id = this.$route.params.id;
                console.log(id);
                await this.$store.dispatch('works/get', id);
                this.work = this.$store.getters['works/work'];
            } catch (e) {
                await this.$store.dispatch(
                    'alerts/error',
                    'Oops, something went wrong!'
                );
            }
        },
        goBack () {
            this.$router.push({ name: 'Works List' });
        },
    },
};

</script>
